import React, { useEffect, useState } from 'react';
import { Breadcrumb, Breadcrumbs } from '~/components/Breadcrumps';
import {
  createTrolleyUrl,
  fetchFinanceTransaction,
  IFinancePayment,
} from '~/modules/Payments/api';
import { useAbility } from '~/lib/ability';
import { PaymentsAbility } from '~/modules/Payments/ability';
import style from './PaymentsTrolleyView.module.scss';
import { Link } from 'react-router-dom';
import { Button } from '~/components/Button';
import { paymentsLinks } from '../links';
import { useDataSource } from '~/lib/dataSource';
import { paymentsAdapter } from '../adapters';
import { Intent } from '~/lib/intent';
import { useModals } from '~/components/Modal';
import { InvoicePaymentsModal } from '../components/InvoicePaymentsModal';
import { Title } from '~/components/Title';

export const PaymentsTrolleyView = () => {
  const alertWireFeeNotice = 'Wires may be subject to banking fees.';
  const alertPaymentFeeWarning =
    'Any fees incurred from returned or failed payments will be the responsibility of the client. Please ensure your payment details and currency are accurate.';

  const ability = useAbility(PaymentsAbility);
  const sellerId = ability.sellerId();

  const { state, fetchRecords } = useDataSource(paymentsAdapter);
  const modals = useModals();
  const invoicesModal = modals.create(InvoicePaymentsModal, {});

  const [trolleyUrl, setTrolleyUrl] = useState<string | null>(null);
  const [invoicePayments, setInvoicePayments] = useState<IFinancePayment[]>([]);

  useEffect(() => {
    if (!sellerId) return;
    fetchRecords(sellerId);
  }, [sellerId]);

  useEffect(() => {
    if (!sellerId) return;
    createTrolleyUrl(sellerId).then((r) => setTrolleyUrl(r.url));
  }, [sellerId]);

  useEffect(() => {
    if (!sellerId) return;

    let cancelled = false;

    fetchFinanceTransaction(sellerId)
      .then((data) => {
        if (cancelled) return;
        setInvoicePayments(data?.payments ?? []);
      })
      .catch(() => {
        if (cancelled) return;
        setInvoicePayments([]);
      });

    return () => {
      cancelled = true;
    };
  }, [sellerId]);

  const openInvoices = () => {
    if (!sellerId) return;
    if (!invoicePayments.length) return;
    invoicesModal.show({ sellerId, payments: invoicePayments });
  };

  return (
    <div className={style.payment}>
      <Breadcrumb breadcrumb={{ title: 'Payments' }}>
        <div className="page-header-sticky">
          <div className="page-header-breadcrumbs">
            <Breadcrumbs />
          </div>
          <Title
            className="page-header-title"
            toolbar={
              <>
                {invoicePayments.length > 0 && (
                  <Button intent={Intent.SUCCESS} onClick={openInvoices}>
                    Invoices
                  </Button>
                )}
                {state?.records.length > 0 && (
                  <Link to={paymentsLinks.payments()}>
                    <Button>Old UI</Button>
                  </Link>
                )}
              </>
            }
          >
            Payments
          </Title>
        </div>
        <div className={`layout-content-box ${style.paymentContent}`}>
          {trolleyUrl && <iframe className={style.iframe} src={trolleyUrl} />}
        </div>
      </Breadcrumb>
    </div>
  );
};
